module.exports = __webpack_public_path__ + "static/media/shield-light-blue.7a65764c.svg";